// Determine API URL based on environment
const getApiUrl = () => {
  // Check if we're in a Vercel PR preview deployment
  const prId = import.meta.env.VITE_VERCEL_GIT_PULL_REQUEST_ID;
  if (prId) {
    const prUrl = `https://pr-${prId}---byggve-api-245372926864.europe-north2.run.app`;
    console.log(`🚀 Using PR-specific API URL for PR #${prId}:`, prUrl);
    return prUrl;
  }

  if (import.meta.env.MODE === "development") {
    // VITE_CLOUD_RUN_URL is set by dt (DevTree) per worktree to the correct
    // Docker port.  Falls back to 3000 for vanilla `npm run dev`.
    const devUrl = import.meta.env.VITE_CLOUD_RUN_URL || "http://localhost:3000";
    console.log("🔧 Using development API URL:", devUrl);
    return devUrl;
  }

  // Use environment variable or default to production
  const apiUrl =
    import.meta.env.VITE_API_URL || "https://byggve-api-245372926864.europe-north2.run.app";
  console.log("🌐 Using production API URL:", apiUrl);
  return apiUrl;
};

export const CLOUD_RUN_URL = getApiUrl();
export const API_URL = CLOUD_RUN_URL;
